module.exports = __webpack_public_path__ + "media/images/sp/stores/namba/namba_sns_03-56eba94db97722830b970de4e9a74f31.jpg";